import {createContext, useContext} from 'react'

interface DetailLayoutContextValue {
  isSectionsDrawerOpen: boolean
  sectionsDrawerWidth: string
}

const defaultDetailLayout: DetailLayoutContextValue = {
  isSectionsDrawerOpen: true,
  sectionsDrawerWidth: '600px'
}
const DetailLayoutContext = createContext<DetailLayoutContextValue>(defaultDetailLayout)


interface DetailLayoutProviderProps {
  children: React.ReactNode
  value: DetailLayoutContextValue
}

export const DetailLayoutProvider = ({children, value}: DetailLayoutProviderProps) => {
  return <DetailLayoutContext.Provider value={value}>{children}</DetailLayoutContext.Provider>
}

export const useDetailLayout = () => {
  const context = useContext(DetailLayoutContext)

  if (!context) {
    throw new Error('useDetailLayout must be used within a DetailLayoutProvider')
  }

  return context
}
